import './index.scss'
import {CheckIcon, ErrorIcon} from '../../../icons'
import {ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import {envConfig} from '../../../utils/env'

const Alert = () => {
    return (
        <ToastContainer position="top-center" autoClose={envConfig.alertDuration} toastOptions={{
            success: {
                icon: <span><CheckIcon/></span>
            },
            error: {
                icon: <span><ErrorIcon/></span>
            }
        }}/>
    )
}

export default Alert
